/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Badge_HintInputs */

const en_directory_submit_badge_hint = /** @type {(inputs: Directory_Submit_Badge_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check the box, then verify the website URL above. We will look for the badge in the page source.`)
};

const zh_directory_submit_badge_hint = /** @type {(inputs: Directory_Submit_Badge_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`勾选后验证上方的网站地址。我们会在页面源码中查找徽章。`)
};

/**
* | output |
* | --- |
* | "Check the box, then verify the website URL above. We will look for the badge in the page source." |
*
* @param {Directory_Submit_Badge_HintInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_badge_hint = /** @type {((inputs?: Directory_Submit_Badge_HintInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Badge_HintInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_badge_hint(inputs)
	return zh_directory_submit_badge_hint(inputs)
});
export { directory_submit_badge_hint as "directory.submit.badge_hint" }